import api from 'api';

export const loadDataTablePartnerUsers = api('POST /api/partner-users/grid');

export const loadPartnerUser = api('GET /api/partner-users/:id');
export const createPartnerUser = api('POST /api/partner-users');
export const updatePartnerUser = api('PUT /api/partner-users/:id');
export const blockPartnerUser = api('POST /api/partner-users/:id/block');
export const unblockPartnerUser = api('POST /api/partner-users/:id/unblock');
export const exportPartnerUsers = api('POST /api/partner-users/export', {
  responseType: 'blob',
});
export const updatePermissions = api('POST /api/partner-users/permissions');
